var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdp-aside-top" },
    [
      _c(
        "div",
        { staticClass: "back-to-results-container text-uppercase mb-2" },
        [
          _c(
            "a",
            {
              staticClass: "color-light-grey back-to-results-link",
              attrs: { href: "javascript:void(0)" },
              on: { click: _vm.goBack }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("span", { staticClass: "back-to-results-text ml-1" }, [
                _vm._v(" Back to Results ")
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "h4",
        {
          staticClass:
            "primary-heading mb-0 font-weight-bold mb-3 patcraft-text-underline",
          attrs: {
            "data-text": _vm.processedHeading
              ? _vm.processedHeading.slice(0, 3)
              : ""
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.processedHeading) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "description text-uppercase" }, [
        _c("ul", { staticClass: "list-unstyled mb-0 mobile-view" }, [
          _c("li", { staticClass: "color-light-grey" }, [
            _vm._v(_vm._s(_vm.sellingStyleNumber))
          ]),
          _vm._v(" "),
          !_vm.isResinous
            ? _c("li", { staticClass: "product-size-imperial" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.selectedProduct.productSizeImperial) +
                    "\n      "
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description text-uppercase" }, [
        _c(
          "ul",
          {
            staticClass:
              "list-unstyled d-flex flex-wrap flex-column dividers-primary mx-n2"
          },
          [
            _vm.collectionRedirect ||
            (_vm.productData && _vm.productData.collectionCode)
              ? _c("li", { staticClass: "px-2 border-0 mt-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "collection-link",
                      attrs: {
                        href: _vm.collectionRedirect
                          ? _vm.collectionRedirect
                          : "/product-collection/" +
                            _vm.getCollectionLink(
                              _vm.productData.collectionCode.description,
                              _vm.productData.collectionCode.code
                            )
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.productData.collectionCode.description) +
                          "\n        "
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.productData.specificationCustomData &&
            _vm.productData.specificationCustomData.patentStatus
              ? _c("li", { staticClass: "px-2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.productData.specificationCustomData.patentStatus
                      ) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _vm.selectedColor.colorVariationLevel &&
      _vm.selectedColor.colorVariationLevel.code &&
      _vm.productData.inventoryType == "resilient"
        ? _c("pc-product-color-variation", { attrs: { specification: false } })
        : _vm._e(),
      _vm._v(" "),
      _vm.weldRodsEnabled ? _c("pc-product-recommended-weldrods") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-container" }, [
      _c("i", {
        staticClass: "fa fa-long-arrow-left",
        attrs: { "aria-hidden": "true" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }